<template>
  <ic-ajax-typeahead
    v-model="idHafas"
    :id="id"
    :url="url"
    :text="stationName"
    :getValue="getStationValue"
    :getText="getStationText"
    v-on:update:text="stationName = $event"
    v-on:update:item="station = $event"
    v-on:is:loading="loading = $event"
    :onInputChange="onInputChange"
    :minLength="3"
    :selectFirst="true"
    :loading="loading"
    :name="name"
  ></ic-ajax-typeahead>
</template>

<script>
import IcAjaxTypeahead from "./AjaxTypeAhead.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import isUndefined from "lodash/isUndefined";

const _ = { isUndefined };

export default {
  name: "IcStationTypeahead",
  props: {
    name: {
      type: String,
      default: "connectionTypeachead"
    },      
    id: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    text: {
      type: String
    },
    valueField: {
      type: String,
      default: "h"
    },
    nameField: {
      type: String,
      default: "n"
    },
    onlyFirstWord: {
      type: Boolean,
      default: false
    },
    v: {
      type: Object
    },
    noMeta: {
      type: Number,
      default: 0
    },
    icStation: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      idH:0,
      idHafas: this.value,
      stationName: this.text,
      station: null,
      url:(window.outsidemodx?"assets/station-get/?q=:query":
        process.env.IC_AJAX_ROOT +
        "/station/get?q=:query") +
        "&ic_station=" +
        this.icStation +
        (this.noMeta == 1 ? "&nometa=1" : ""),
      loading: false
    };
  },
  watch: {
    idHafas: function(newValue) {
      this.$emit("input", newValue);
    },
    stationName: function(newValue) {
      this.$emit("update:text", newValue);
    },
    value: function(newValue) {
      this.idHafas = newValue;
      if (this.valueField == "n") {
        this.stationName = newValue;
      }
      
    },
    station:{
      deep:true,
      handler(newValue){
        if(newValue && newValue.h){
          this.idH = newValue.h;
          this.$emit('idStation',this.idH);
        }
      }
    },
    text: function(newValue) {
      this.stationName = newValue;
    }
  },
  methods: {
    getStationValue(item) {
      return item && item[this.valueField] ? item[this.valueField] : "";
    },
    getStationText(item) {
      return item && item[this.nameField] ? item[this.nameField] : "";
    },
    onInputChange(query) {
      this.loading = true;
      if (this.v) {
        this.v.$touch();
      }

      if (query.trim().length === 0) {
        return null;
      }

      if (this.onlyFirstWord) {
        query = query.split(" ")[0];
      }

      const url = this.url.replace(":query", encodeURI(query));
      return new Promise(resolve => {
        axios.get(url).then(response => {
          let items = [];
          response.data.forEach(item => {
            items.push(item);
          });
          resolve(items);
          this.loading = false;
        });
      });
    }
  },
  components: {
    IcAjaxTypeahead
  }
};
</script>

<style>
</style>
